import { axiosObject } from "../config";

export default function createFile(file: any, params: any) {
    return new Promise((resolve, reject) => {
        let uri = "auction/data/resource/files/_create";
        let data = new FormData();
        data.append("file", file);
        axiosObject
            .post(uri, data, {
                params: params,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}


